"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.WidgetRoot = exports.ViewAll = exports.TitleArea = exports.Title = void 0;
var _mui = require("@ori-ui/mui");
const classes = exports.classes = {
  noScroll: 'olapicWidget-noScroll'
};
const WidgetRoot = exports.WidgetRoot = (0, _mui.styled)('section')(({
  theme
}) => ({
  [`.${classes.noScroll}`]: {
    overflow: 'hidden'
  },
  marginTop: theme.spacing(12),
  marginBottom: theme.spacing(8),
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    position: 'relative',
    marginTop: theme.spacing(14),
    marginBottom: theme.spacing(14)
  }
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const TitleArea = exports.TitleArea = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'block',
  maxWidth: 600,
  margin: theme.spacing(0, 'auto', 6),
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(0, 'auto', 8)
  }
}));
const ViewAll = exports.ViewAll = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  margin: theme.spacing(2, 'auto', 0),
  textAlign: 'center',
  [theme.breakpoints.up('lg')]: {
    position: 'absolute',
    top: 0,
    right: theme.spacing(6),
    margin: 0
  }
}));
